<template>
    <section>
        <base-card>
            <h2>Page Not Found</h2>
            <p>This page could not be found. Maybe check our list of <router-link to="/mentors"> mentors</router-link></p>
        </base-card>
    </section>
</template>